import { resetClocks } from 'services/adminServices'
import AuthContext from 'contexte/AuthContext'
import './mainActions.css'
import Notification from 'components/notifications/Notification'
import { useContext } from 'react'
import { launchError, launchSuccess } from 'components/notifications'
import { useTranslation } from 'react-i18next'


const MainActions = ({ mainActionsData }) => {

    const { user, verifyUser } = useContext(AuthContext)
    const { t } = useTranslation();

    const role = verifyUser()?.role;

    const reset = async () => {
        try {
            console.log('reset clicked')
            await resetClocks(user)
            launchSuccess(t('notifications.home.clock.success'))
        } catch (e) {
            launchError(t('notifications.home.clock.error'))
        }
    }

    const actions = [
        {
            count: mainActionsData?.payouts?.length || "0",
            label: "Payouts en cours",
            href: "/finances/payouts",
            iconClass: "home_action_icon_payouts",
            icon: "💳"
        },
        {
            count: mainActionsData?.deposits?.length || "0",
            label: "Dépôts externes",
            href: "/finances/external-deposit",
            iconClass: "home_action_icon_deposits",
            icon: "🏦"
        },
        {
            count: mainActionsData?.ibans?.length || "0",
            label: "IBANs à valider",
            href: "/finances/iban",
            iconClass: "home_action_icon_ibans",
            icon: "🔢"
        },
        {
            count: mainActionsData?.utilityBill?.length || "0",
            label: "Justificatifs de domicile",
            href: "/finances/utility-bills",
            iconClass: "home_action_icon_utility",
            icon: "📄"
        },
        {
            count: mainActionsData?.agoDeposits || "0",
            label: "Dépôts externes AGO",
            href: "/ago/deposits",
            iconClass: "home_action_icon_ago_deposits",
            icon: "📥"
        },
        {
            count: mainActionsData?.agoWithdraws?.data || "0",
            label: "Payouts en cours AGO",
            href: "/ago/payouts",
            iconClass: "home_action_icon_ago_payouts",
            icon: "📤"
        }
    ]

    return (
        <div className='main_action_box'>
            <Notification />
            <div className='main_action_header'>
                <h3>Actions en attente</h3>
                {role === 1 && (
                    <button className='reset_clock_button' onClick={reset}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
                        </svg>
                        Reset Clock
                    </button>
                )}
            </div>
            <div className='home_action_main'>
                {actions.map((action, index) => (
                    <a className='home_action_first_box' href={action.href} key={index}>
                        <div className={`home_action_icon ${action.iconClass}`}>
                            {action.icon}
                        </div>
                        <div className='home_action_info'>
                            <p>{action.count}</p>
                            <div className='home_action_first_box_text'>
                                <span>{action.label}</span>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="9 18 15 12 9 6"/>
                                </svg>
                            </div>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    )
}

export default MainActions